import React from 'react';

import get from 'lodash/get';

import Typography from 'components/Typography';
import { DateValueFormatter } from 'intl';

import { IDescriptionMetadata } from './interfaces';

export const DescriptionMetadata: React.FC<IDescriptionMetadata> = ({
  value,
  userField = 'user.name',
  dateField = 'date',
  template = 'LLL',
  timeZone = 'local',
  ...other
}) => {
  const user = get(value, userField);
  const date = get(value, dateField);

  return (
    <div {...other}>
      <Typography>{user}</Typography>
      <Typography>
        <DateValueFormatter
          value={date}
          template={template}
          timeZone={timeZone}
        />
      </Typography>
    </div>
  );
};
